import React from 'react'
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom'
import { imageAddress, pathMaker, translate } from '../utils/useful';
import ButtonAnimated from './buttons/ButtonAnimated';

class PermissionDenied extends React.Component {



    render() {

        return (

            <div className="w-100 px-4 py-4  h-100 scroll-no-scrollbar window-content-radius " style={{ background: 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))' }}>
                {/* <div className='w-100 h-100 position-absolute overflow-hidden' >
                        <div className='animated-bg' style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}></div>
                    </div> */}

                <div className='flexcc w-100 '>
                    <div className='br-8 px-4 py-4 pb-5' style={{ maxWidth: 400, background: '#fff', marginTop: '5%', boxShadow: '0px 0px 50px #10101020' }}>

                        <div className='d-flex justify-content-center mb-3 mt-3'>
                            <div className='px-1 flexc flex-column ' style={{width:100,maxWidth:100}}>
                                <img src={imageAddress(this.props.applet?.image, "profile")} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                <p className='text-smaller mt-1 text-semibold text-center'>{this.props.applet?.hub?.name}</p>
                            </div>

                            <div className='opacity-2' style={{marginTop:18}}>
                                <img src={'/assets/icons/useful/switchView1.png'} style={{ width: 20, height: 20 }} />
                            </div>

                            <div className='px-1  flexc flex-column ' style={{width:100,maxWidth:100}}>
                                <img src={imageAddress(this.props.applet?.image, "applet")} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                <p className='text-smaller mt-1 text-semibold text-center '>{this.props.applet?.name}</p>
                            </div>
                        </div>

                        <p className=" text-big text-bold text-center" >{translate('Login is required')}</p>
                        <p className=" text-normal mt-1 text-bold text-center" >{translate('Permission Denied')}</p>

                        <p className=" text-smaller text-center mt-2" style={{ margin: '0px 0px 0px 0px' }}>{translate('You need to be logged in, for accessing this section. After login your privilege will be ckecked again automatically')}</p>
                        {/* <button>
                                <p className='text-small mt-1' style={{ color: 'rgb(88, 86, 214)' }}>Login to the platform</p>
                            </button> */}


                        {/* {this.props.applet && (
                                <button className='mt-3 br-20 px-2 py-2 w-100 ' style={{ background: this.props.colors?.background, color: this.props.colors?.textColor, border: '1px solid #eee' }}>


                                    <div className='  flexc w-100' >
                                        <div>
                                            <img src={imageAddress(this.props.applet.image, "applet")} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                                        </div>

                                        <div className='mld-3 text-start'>
                                            <p className='text-normal text-semibold' >{this.props.applet?.name}</p>
                                            <p className='text-smaller'>{this.props.applet?.hub?.name}</p>
                                        </div>
                                    </div>

                                </button>
                            )} */}

                        <div className='mt-3 flexcc'>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => this.props.addNewWindow("authentication", {}, "center")}
                                title={translate("Login now")}
                                icon='/assets/icons/arrow-right-white.svg'
                                textColor={'#fff'}
                                // invert={this.props.colors?.iconInvert}
                                bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                            />
                        </div>

                        {/* <p className="mt-2 text-normal text-semibold ">{translate('Applet info')}</p> */}

                        {/* <p className='text-small color-gray-2 mt-3'>What is yonnect?</p> */}
                    </div>
                </div>
                {/* <p className=" text-mega-big m-0">401</p> */}
            </div>
        )

    }
}

export default withRouter(PermissionDenied);